import React, { useState, useEffect, Fragment, useContext } from "react";
import { BackLink } from "../common/BackLink";
import { NextLink } from "../common/NextLink";
import { NavFooter } from "../common/NavFooter";
import { Transition } from "@headlessui/react";
import _ from "lodash";
import { useLocation, useHistory } from "react-router";
import { GenericModal } from "../common/GenericModal";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { DashboardHeader } from "../DashboardHeader";

export const SetupDataPageTemplate = ({
	children,
	headerDetails,
	backTo,
	nextTo,
	onClickBack,
	onClickNext,
	backTextOverride,
	nextTextOverride,
	hideNext,
	modalOptions,
}) => {
	const location = useLocation();
	const isFromBackLink = location?.state?.isFromBackLink;

	const [isShowing, setIsShowing] = useState(false);

	const { theme } = useContext(DiseaseGroupContext);

	useEffect(() => {
		setIsShowing(true);
	}, []);

	useEffect(() => {
		if (modalOptions) {
			const tempOptions = {
				title: modalOptions.title ?? "Confirm",
				backText: modalOptions.backText ?? null,
				nextText: modalOptions.nextText ?? null,
				content: modalOptions.content ?? "Continue?",
				enableModal: modalOptions.enableModal ?? true,
			};

			setInternalModalOptions(tempOptions);
		}
	}, [modalOptions]);

	const history = useHistory();

	let onClickNextFunction,
		onClickNextAsync = null;

	const textColor = "white";

	if (onClickNext) {
		if (_.isFunction(onClickNext)) {
			onClickNextFunction = onClickNext;
		} else {
			onClickNextFunction = onClickNext.func;
			onClickNextAsync = onClickNext.async;
		}
	}

	const [isModalShowing, setIsModalShowing] = useState(false);

	const [internalModalOptions, setInternalModalOptions] = useState({
		enableModal: false,
	});

	const modalOnFinish = () => {
		if (onClickNextAsync === true) {
			setIsModalShowing(false);
			setIsShowing(false);
			onClickNextFunction()
				.catch(() => {})
				.finally(() => {
					history.push(nextTo);
				});
		} else {
			setIsModalShowing(false);
			setIsShowing(false);
			try {
				onClickNextFunction();
			} catch (ex) {}
			history.push(nextTo);
		}
	};

	return (
		<div
			className={`fixed inset-0 text-black ${
				isShowing ? theme.primary().bg() : ""
			}`}
		>
			<Transition
				className={`flex flex-col w-full h-full relative`}
				appear={true}
				show={isShowing}
				enter={`transform ease-in-out duration-500`}
				enterFrom={isFromBackLink ? "-translate-x-full" : "translate-x-full"}
				enterTo={"translate-x-0"}
				leave={`transition-opacity ease-in-out duration-200`}
				leaveFrom={"opacity-100"}
				leaveTo={"opacity-0"}
			>
				<div className={"w-full max-w-xl mx-auto sm:px-3"}>
					<DashboardHeader
						title={headerDetails.title}
						subtitle={`Page ${headerDetails.currentPage} of ${headerDetails.pageCount}`}
					/>
				</div>
				{/* Page Content */}
				<div
					className={
						"flex-grow overflow-y-auto px-6 pt-2 sm:px-8 sm:pt-8 text-black bg-white rounded-t-xxl"
					}
				>
					<div className={"mb-28 text-black max-w-panel mx-auto pt-4"}>
						{children}
						<GenericModal
							show={isModalShowing && internalModalOptions.enableModal}
							onClose={() => setIsModalShowing(false)}
							onNext={modalOnFinish}
							title={internalModalOptions.title}
							text={internalModalOptions.content}
							backText={internalModalOptions.backText}
							nextText={internalModalOptions.nextText}
						/>
					</div>
				</div>

				{/* Footer */}
				<div className={"absolute left-0 right-0 bottom-0"}>
					<NavFooter
						currentTheme={theme.primary()}
						textColor={textColor}
						smallPrint={`\u00A9 2021 Dash-Global Ltd.`}
					>
						{backTo || onClickBack ? (
							<BackLink
								to={backTo}
								onClick={onClickBack}
								textOverride={backTextOverride}
								delay={200}
								onDelayStart={() => setIsShowing(false)}
								variant="navigationText"
								hideIcon={true}
							/>
						) : null}
						{!hideNext &&
						(nextTo || onClickNext) &&
						!internalModalOptions.enableModal ? (
							<NextLink
								to={nextTo}
								onClick={onClickNextFunction}
								onClickAsync={onClickNextAsync}
								textOverride={nextTextOverride}
								delay={200}
								onDelayStart={() => setIsShowing(false)}
								variant="navigationText"
							/>
						) : null}
						{!hideNext &&
						(nextTo || onClickNext) &&
						internalModalOptions.enableModal ? (
							<>
								<NextLink
									onClick={() => setIsModalShowing(true)}
									textOverride={nextTextOverride}
									variant="navigationText"
								/>
							</>
						) : null}
					</NavFooter>
				</div>
			</Transition>
		</div>
	);
};
